import { Section } from "../components/sections/TextSection";
import { borderProps } from "./commonPropInfo";

export const RectangleConfig: Section = {
    row: 0,
    col: 0,
    name: 'Rectangle',
    type: 'rectangle',
    id: '1',
    selected: false,
    height: 60,
    width: 60,
    rowCount: 10,
    colCount: 10,
    textContent: "",
    x: 0,
    y: 0,
    isLocked: false,
    propInfo: [
        {
            name: "background",
            inputType: 'gradientcolor',
            binding: 'style.background',
            value: '',
            label: 'Background',
        },    
        {
            name: "Rotation",
            inputType: 'number',
            binding: 'style.transform',
            value: 0,
            label: 'Rotation',
        },
        ...borderProps
    ]
};
